import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { setNewCredential } from 'src/api/lib/auth';
import { ApiError } from 'src/types/interfaces/api-error';

export const useSetNewCredential = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: ({ token, password }: { token: string; password: string }) =>
      setNewCredential(token, password),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
